function BusinessModel(serverBusinessModel) {

  var self = this;

  self.businessId = serverBusinessModel.businessId;
  self.businessName = serverBusinessModel.businessName;
  self.businessAddress = serverBusinessModel.businessAddress;
  self.coordinate = serverBusinessModel.coordinate;
}

export default BusinessModel;
